module.exports = __webpack_public_path__ + "img/park.49c225eb.png";